import React from 'react';
import { EyeIcon, Trash2Icon, SettingsIcon } from 'lucide-react';
interface DesignCardProps {
  design: {
    id: string;
    name: string;
    type: string;
    desiredStock: number;
    atHand: number;
    incoming: number;
    lowStock: number;
    overStock: number;
    covered: number;
    orderRequired: number;
  };
  isConsolidated?: boolean;
}
export function DesignCard({
  design,
  isConsolidated
}: DesignCardProps) {
  const stockPercentage = isConsolidated ? 64 : Math.round(design.atHand / (design.desiredStock || 1) * 100);
  const isCritical = stockPercentage < 30;
  return <div className={`bg-white rounded-lg border p-5 ${isConsolidated ? 'border-blue-400 lg:col-span-2 shadow-lg shadow-blue-500/10' : 'border-gray-200'}`} data-id="element-95">
      <div className="flex items-start justify-between mb-4" data-id="element-96">
        <div data-id="element-97">
          <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-98">
            {design.name}
          </h3>
          <span className="inline-block px-2.5 py-1 bg-blue-50 text-blue-700 rounded text-sm font-medium" data-id="element-99">
            {design.type}
          </span>
          {!isConsolidated && <p className="text-sm text-gray-600 mt-2" data-id="element-100">
              Desired stock: {design.desiredStock}
            </p>}
        </div>
        <div className="text-right" data-id="element-101">
          <p className={`text-3xl font-bold ${isCritical ? 'text-red-600' : 'text-gray-900'}`} data-id="element-102">
            {stockPercentage}%
          </p>
          <p className="text-sm text-gray-500 mt-1" data-id="element-103">Stock Level</p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-104">
        <div className="p-3 bg-blue-50 rounded border border-blue-200" data-id="element-105">
          <p className="text-sm text-blue-700 mb-1" data-id="element-106">At hand</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-107">
            {design.atHand} machine(s)
          </p>
        </div>
        <div className="p-3 bg-blue-50 rounded border border-blue-200" data-id="element-108">
          <p className="text-sm text-blue-700 mb-1" data-id="element-109">Incoming</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-110">
            {design.incoming} machine(s)
          </p>
        </div>
      </div>
      <div className="space-y-2 mb-4" data-id="element-111">
        <div className="flex items-center justify-between text-sm" data-id="element-112">
          <span className="text-gray-700" data-id="element-113">Low Stock</span>
          <span className="font-semibold text-gray-900" data-id="element-114">
            {design.lowStock}%
          </span>
        </div>
        <div className="flex items-center justify-between text-sm" data-id="element-115">
          <span className="text-gray-700" data-id="element-116">Over Stock</span>
          <span className="font-semibold text-gray-900" data-id="element-117">
            {design.overStock}%
          </span>
        </div>
        <div className="flex items-center justify-between text-sm" data-id="element-118">
          <span className="text-gray-700" data-id="element-119">Covered</span>
          <span className="font-semibold text-gray-900" data-id="element-120">{design.covered}%</span>
        </div>
        {design.orderRequired > 0 && <div className="flex items-center justify-between text-sm bg-red-50 -mx-1 px-1 py-1 rounded" data-id="element-121">
            <span className="text-red-700 font-medium" data-id="element-122">Order required</span>
            <span className="font-semibold text-red-600" data-id="element-123">
              {design.orderRequired}%
            </span>
          </div>}
      </div>
      <div className="flex items-center gap-2 pt-4 border-t border-gray-200" data-id="element-124">
        <button className="flex-1 flex items-center justify-center gap-2 px-4 py-2 text-blue-600 hover:bg-blue-50 rounded transition-colors border border-blue-200" data-id="element-125">
          <EyeIcon className="w-4 h-4" data-id="element-126" />
          View
        </button>
        {!isConsolidated && <>
            <button className="flex items-center justify-center gap-2 px-4 py-2 text-gray-600 hover:bg-gray-50 rounded transition-colors border border-gray-200" data-id="element-127">
              <SettingsIcon className="w-4 h-4" data-id="element-128" />
            </button>
            <button className="flex items-center justify-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50 rounded transition-colors border border-red-200" data-id="element-129">
              <Trash2Icon className="w-4 h-4" data-id="element-130" />
            </button>
          </>}
      </div>
    </div>;
}